import { render, staticRenderFns } from "./ProxyServiceModal.vue?vue&type=template&id=72d1def6&scoped=true"
import script from "./ProxyServiceModal.vue?vue&type=script&lang=js"
export * from "./ProxyServiceModal.vue?vue&type=script&lang=js"
import style0 from "./ProxyServiceModal.vue?vue&type=style&index=0&id=72d1def6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d1def6",
  null
  
)

export default component.exports